"use client";

import { useEffect, useState } from "react";

import { Icon } from "@cobasi/ds-icons";
import ChevronDown from "@cobasi/ds-icons/solid/chevronDown";

import type { AccordionProps } from "./accordion.types";

import s from "./accordion.module.scss";

const Accordion = ({
  id,
  title,
  children,
  showAccordion = true,
  showClosed = true,
  icon,
  customStyles
}: AccordionProps) => {
  const [expanded, setExpanded] = useState<string | false>(
    showClosed ? false : id
  );

  useEffect(() => {
    setExpanded(showClosed ? false : id);
  }, [showClosed, id]);

  return showAccordion ? (
    <div
      className={`${customStyles?.root || s.wrapper} ${expanded === id ? s.expanded : ""}`}
    >
      <div
        className={`card-headline ${[s["card-headline"]]} ${customStyles?.headline || ""}`}
        id={id}
        data-testid="accordion"
        onClick={() => setExpanded(expanded === id ? false : id)}
        role="button"
        aria-expanded={expanded === id}
      >
        {icon && <div className={`card-icon ${s["card-icon"]}`}>{icon}</div>}
        <div className="card-body">
          <h3
            className={`${s["card-title"]} ${customStyles?.title || "card-title"}`}
          >
            {title}
          </h3>
        </div>
        <div className="card-action">
          <button
            aria-label="Botão de ação"
            className={`card-action-button ${s["card-action-button"]}`}
            type="button"
          >
            <Icon
              icon={ChevronDown}
              className={`${s.icon} ${expanded === id ? s["icon-rotated"] : ""}`}
            />
          </button>
        </div>
      </div>
      <div
        data-testid="accordion-details"
        className={`${customStyles?.body || s["accordion-body"]} ${expanded === id ? customStyles?.expanded || s.expanded : ""}`}
      >
        <div>{children}</div>
      </div>
    </div>
  ) : null;
};
export default Accordion;
